export const selectPortal = (state) => state.portal
